export default __webpack_public_path__ + "static/media/Pic1.651e9c4b.jpg";